import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, apiError } from "../lib/api";

const field = "w-full border-b border-line bg-transparent py-3 text-base text-ink outline-none placeholder:text-graphite focus:border-ink";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/auth/me").then(() => nav("/admin", { replace: true })).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-[90vh] place-items-center bg-ivory px-5 pt-32" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 md:p-10" data-testid="admin-login-form">
        <img src="/img/emblem.png" alt="" className="h-14 w-14" />
        <p className="label-mono mt-6">Private · Admin</p>
        <h1 className="mt-2 font-display text-4xl font-light text-ink">Sign in</h1>
        <div className="mt-8 space-y-5">
          <input type="email" required autoComplete="username" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="admin-email-input" />
          <input type="password" required autoComplete="current-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-4 text-sm text-[#9B1C1C]" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn-dark mt-8 w-full" data-testid="admin-login-submit"><Lock className="h-4 w-4" />{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
